import useVerifySuccessSync from "./useVerifySuccessSync";
import useWebUserDerivedSync from "./useWebUserDerivedSync";

const useLoginOTPInterface = () => {
  useVerifySuccessSync();
  useWebUserDerivedSync();
};

export default useLoginOTPInterface;
